module.exports = __webpack_public_path__ + "img/KIT CC 2 .81426eca.jpg";